// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CreditMemo } from './credit-memo';
import { CreditMemoLedgerEntryKind } from './credit-memo-ledger-entry-kind';
import { CreditMemoLedgerEntryKindEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditMemoLedgerEntry extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Decimal */
  amount!: number;
  /** Int32 FK creditMemo */
  creditMemoId!: number;
  /** Enum FK kind */
  kindId!: CreditMemoLedgerEntryKindEnum;
  /** String */
  notes?: string;
  /** FK creditMemoId */
  creditMemo!: CreditMemo;
  /** FK kindId */
  kind!: CreditMemoLedgerEntryKind;
}

